import { useState } from 'react';
import { Dealer } from '../../../../domains/Dealer';
import { useRevealDealerPhoneMutation } from './useRevealDealerPhoneMutation';
import { useTrackDealerShowroomCallMutation } from './useTrackDealerShowroomCallMutation';

const useDealerContactDetails = (dealer: Dealer) => {
  const [showEmail, setShowEmail] = useState(false);
  const [isLocationOpen, setLocationOpen] = useState(false);
  const [dealerPhone, setDealerPhone] = useState('');
  const revealPhoneMutation = useRevealDealerPhoneMutation();
  const trackCallMutation = useTrackDealerShowroomCallMutation();

  const handleShowPhoneNumber = () => {
    if (dealerPhone) {
      // Number already revealed → this click dials the tel: link (the actual call)
      trackCallMutation.mutate(dealer.id);
      return;
    }
    revealPhoneMutation.mutate(dealer.id, {
      onSuccess: (data) => {
        setDealerPhone(data.displayFormat);
      },
    });
  };

  return {
    dealerPhone,
    handleShowPhoneNumber,
    isSubmitting: revealPhoneMutation.isPending,
    isLocationOpen,
    setLocationOpen,
    showEmail,
    setShowEmail,
  };
};

export { useDealerContactDetails };
